import { ActiveInvocationsStatus } from "@/shared/components/actions/ActiveInvocationsStatus";
import { useActiveInvocations } from "@/shared/domain/actions/useActiveInvocations";

interface DatasetActionStatusProps {
  datasetId: string;
}

/** After the dataset's Actions tab label: whether any invocation on the dataset is pending or running. */
export function DatasetActionStatus({ datasetId }: DatasetActionStatusProps) {
  const invocationsQuery = useActiveInvocations(datasetId);
  return <ActiveInvocationsStatus invocations={invocationsQuery.data?.items} />;
}
